export default {
  DEBTOR_ONBOARDING_CALCULATOR_MIN: 'DEBTOR_ONBOARDING_CALCULATOR_MIN',
  DEBTOR_ONBOARDING_CALCULATOR_MAX: 'DEBTOR_ONBOARDING_CALCULATOR_MAX',
  DEBTOR_ONBOARDING_CALCULATOR_MAX_EXISTING: 'DEBTOR_ONBOARDING_CALCULATOR_MAX_EXISTING',
  DEBTOR_HIGHER_MAX_LOAN_AMOUNT_MAX_RATING: 'DEBTOR_HIGHER_MAX_LOAN_AMOUNT_MAX_RATING',
  DEBTOR_HIGHER_MAX_LOAN_AMOUNT_MIN_PAID_LOANS: 'DEBTOR_HIGHER_MAX_LOAN_AMOUNT_MIN_PAID_LOANS',
  DEBTOR_ONBOARDING_CALCULATOR_STEP: 'DEBTOR_ONBOARDING_CALCULATOR_STEP',
  DEBTOR_CALCULATOR_DEFAULT_AMOUNT: 'DEBTOR_CALCULATOR_DEFAULT_AMOUNT',
  DEBTOR_CALCULATOR_DEFAULT_MONTHS: 'DEBTOR_CALCULATOR_DEFAULT_MONTHS',

  LOAN_EXPIRATION_DAYS: 'LOAN_EXPIRATION_DAYS',
  DUE_NOTICE_1_DAYS: 'DUE_NOTICE_1_DAYS',
  DUE_NOTICE_2_DAYS: 'DUE_NOTICE_2_DAYS',
  REDEMPTION_DAYS: 'REDEMPTION_DAYS',
  INTEREST_RANGE: 'INTEREST_RANGE',
  MAX_NUMBER_OF_OPEN_LOANS: 'MAX_NUMBER_OF_OPEN_LOANS',

  CREDITOR_ONBOARDING_CALCULATOR_MIN: 'CREDITOR_ONBOARDING_CALCULATOR_MIN',
  CREDITOR_ONBOARDING_CALCULATOR_MAX: 'CREDITOR_ONBOARDING_CALCULATOR_MAX',
  CREDITOR_ONBOARDING_CALCULATOR_STEP: 'CREDITOR_ONBOARDING_CALCULATOR_STEP',
  CREDITOR_CALCULATOR_DEFAULT_AMOUNT: 'CREDITOR_CALCULATOR_DEFAULT_AMOUNT',
  CREDITOR_CALCULATOR_DEFAULT_MONTHS: 'CREDITOR_CALCULATOR_DEFAULT_MONTHS',
  CREDITOR_ALLOCATION_TRANSFER_FEE: 'CREDITOR_ALLOCATION_TRANSFER_FEE',
  
  LOAN_PROVISION_FEES: ['6.00', '3.00', '3.00'],

  FIRST_LOAN_PROVISION_FEE: 'FIRST_LOAN_PROVISION_FEE',
  SECOND_LOAN_PROVISION_FEE: 'SECOND_LOAN_PROVISION_FEE',
  OTHER_LOAN_PROVISION_FEE: 'OTHER_LOAN_PROVISION_FEE',

  LOAN_MIN_MONTHS: 'LOAN_MIN_MONTHS',
  LOAN_MAX_MONTHS: 'LOAN_MAX_MONTHS',

  TRUSTPAY_FEE_FROM_PAYMENT: 'TRUSTPAY_FEE_FROM_PAYMENT',
  TRUSTPAY_FEE: 'TRUSTPAY_FEE',

  PRESCORING_ON: 'PRESCORING_ON',
  BIOMETRICS_ON: 'BIOMETRICS_ON',
  BIOMETRIC_THRESHOLD: 'BIOMETRIC_THRESHOLD',

  PSD2_INTEGRATION_ON: 'PSD2_INTEGRATION_ON',
  PSD2_INTEREST_DISCOUNT: 'PSD2_INTEREST_DISCOUNT',
};



// WEBPACK FOOTER //
// ./src/common/enums/settingKeys.js